module.exports = __webpack_public_path__ + "static/img/store.644a6f3e.png";